import { useFormValues } from '@retainerclub/hooks';
import PropTypes from 'prop-types';
import { DatePicker } from '../../../shared';

function ReferralsFormPatientScanReady({
  scanReadyAt = 'patientAttributes.scanReadyAt',
  partnerUploadScanAt = 'patientAttributes.partnerUploadScanAt',
  usePatientAttributes = true,
}) {
  const { patientAttributes, scanReady } = useFormValues();

  const isScanAvailable =
    (usePatientAttributes && patientAttributes?.scanReady) ||
    (!usePatientAttributes && scanReady);

  return (
    <>
      {isScanAvailable ? (
    <div className="relative col-span-full sm:col-span-2">
          <DatePicker
            name={partnerUploadScanAt}
            label="Date the scan was sent"
            required
          />
    </div>
  ) : (
        <div className="relative col-span-full hidden sm:col-span-2">
          <DatePicker
            name={partnerUploadScanAt}
            label="Date the scan was sent"
            required
          />
        </div>
      )}
      {!isScanAvailable ? (
    <div className="relative col-span-full sm:col-span-2">
      <DatePicker
        name={scanReadyAt}
        label="Est. date the scan will be ready"
        isFutureDate
      />
    </div>
      ) : (
        <div className="relative col-span-full hidden sm:col-span-2">
          <DatePicker
            name={scanReadyAt}
            label="Est. date the scan will be ready"
            isFutureDate
          />
        </div>
      )}
    </>
  );
}

ReferralsFormPatientScanReady.propTypes = {
  scanReadyAt: PropTypes.string,
  partnerUploadScanAt: PropTypes.string,
  usePatientAttributes: PropTypes.bool,
};

export default ReferralsFormPatientScanReady;
